(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/numbergames/results/assets/javascripts/radio/campaign.js') >= 0) return;  svs.modules.push('/components/numbergames/results/assets/javascripts/radio/campaign.js');
"use strict";

var _svs$numbergames$resu, _svs$numbergames$resu2, _svs$numbergames$resu3;

const {
  getCampaignDrawDataFetcher,
  getCampaignListDataFetcher
} = svs.numbergames.campaign;
const campaignDrawFetcher = getCampaignDrawDataFetcher();
const campaignListFetcher = getCampaignListDataFetcher();
const {
  recentlyFinishedCampaign,
  activeCampaign
} = (_svs$numbergames$resu = (_svs$numbergames$resu2 = svs.numbergames.results.data) === null || _svs$numbergames$resu2 === void 0 ? void 0 : _svs$numbergames$resu2.campaignData) !== null && _svs$numbergames$resu !== void 0 ? _svs$numbergames$resu : {};
if ((_svs$numbergames$resu3 = svs.numbergames.results.data) !== null && _svs$numbergames$resu3 !== void 0 && _svs$numbergames$resu3.campaignData) {
  const {
    campaignsByDate = {},
    activeCampaign = {}
  } = svs.numbergames.results.data.campaignData;
  Object.assign(campaignDrawFetcher.cache, activeCampaign);
  Object.assign(campaignListFetcher.cache, campaignsByDate);
}
svs.numbergames.results.radio.campaign = Backbone.Radio.channel('campaign');
svs.numbergames.results.radio.campaign.reply('campaign', async _ref => {
  let {
    productId,
    drawNumber,
    date
  } = _ref;
  if (activeCampaign) {
    const [[, campaignData]] = Object.entries(activeCampaign);
    if (campaignData.drawTypeId === 1) {
      return campaignData;
    }
  }
  date = new Date(date);
  const year = date.getFullYear();
  const month = date.getMonth() + 1;
  const campaignList = await svs.numbergames.results.radio.campaign.request('campaignPeriod', {
    productId,
    year,
    month
  });
  const campaignSnippet = svs.numbergames.campaign.filterCampaignListByDrawNumber({
    drawNumber,
    productId,
    campaignList
  });
  if (campaignSnippet) {
    const campaignArray = await campaignDrawFetcher.fetchData({
      product: productId,
      drawNumber: campaignSnippet.drawNumber
    });
    if (Array.isArray(campaignArray) && !(campaignArray !== null && campaignArray !== void 0 && campaignArray.length)) {
      return null;
    }
    const campaign = Array.isArray(campaignArray) ? campaignArray[0] : campaignArray;
    campaign.isClosed = campaign.drawStateId === 4;
    return campaign.drawTypeId > 1 ? campaign : null;
  }
  if (recentlyFinishedCampaign) {
    recentlyFinishedCampaign.isClosed = true;
    const endDate = new Date(recentlyFinishedCampaign.endDate);
    if (dateFns.isAfter(date, endDate)) {
      return recentlyFinishedCampaign;
    }
  }
  return null;
});
svs.numbergames.results.radio.campaign.reply('campaignPeriod', async _ref2 => {
  let {
    productId,
    year,
    month
  } = _ref2;
  return await campaignListFetcher.fetchData({
    product: productId,
    year,
    month
  });
});

 })(window);